/**
 * Compact task list for collapsed view
 */
export function CompactTaskList({ tasks, onSelectTask, hasMore, totalCount }) {
  return (
    <div className="compact-task-list">
      {tasks.map(task => {
        const hasSteps = task.steps && task.steps.length > 0;
        const stepsCompleted = hasSteps ? task.steps.filter(s => s.completed).length : 0;
        const stepsTotal = hasSteps ? task.steps.length : 0;
        const isCompletedOverdue = (task.status === 'completed' || task.status === 'completed-with-issues') &&
                                    task.completedAt &&
                                    task.dueDate < task.completedAt.toDate().toISOString().split('T')[0];

        return (
          <div
            key={task.id}
            className="compact-task-item"
            onClick={() => onSelectTask(task)}
          >
            <span className="compact-task-title">{task.title}</span>
            <div className="compact-task-badges">
              {hasSteps && (
                <span className={`badge badge-steps-compact ${task.status === 'completed-with-issues' ? 'with-issues' : ''}`}>
                  {stepsCompleted}/{stepsTotal}
                </span>
              )}
              {isCompletedOverdue && (
                <span className="badge badge-overdue-compact">⚠️</span>
              )}
            </div>
          </div>
        );
      })}
      {hasMore && (
        <div className="compact-task-more">
          ... und {totalCount - tasks.length} weitere
        </div>
      )}
    </div>
  );
}
